'use client';

import React from 'react';
import { Box } from '@mui/material';
import { spacing } from '@/theme/tokens';

interface StarRatingProps {
    rating: number;
    size?: number;
}

const StarFilledIcon = '/homepage/StarRateFilled.svg';
const StarHalfIcon = '/homepage/StarRateHalfFilled.svg';
const StarEmptyIcon = '/homepage/StarRateOutlined.svg';

export default function StarRating({ rating, size = 28 }: StarRatingProps) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            {[1, 2, 3, 4, 5].map((star) => {
                if (star <= Math.floor(rating)) {
                    return (
                        <Box
                            key={star}
                            component="img"
                            src={StarFilledIcon}
                            alt="Filled star"
                            sx={{
                                width: `${size}px`,
                                height: `${size}px`,
                                flexShrink: 0
                            }}
                        />
                    );
                } else if (star === Math.ceil(rating) && rating % 1 !== 0) {
                    return (
                        <Box
                            key={star}
                            component="img"
                            src={StarHalfIcon}
                            alt="Half star"
                            sx={{
                                width: `${size}px`,
                                height: `${size}px`,
                                flexShrink: 0
                            }}
                        />
                    );
                } else {
                    return (
                        <Box
                            key={star}
                            component="img"
                            src={StarEmptyIcon}
                            alt="Empty star"
                            sx={{
                                width: `${size}px`,
                                height: `${size}px`,
                                flexShrink: 0
                            }}
                        />
                    );
                }
            })}
        </Box>
    );
}
